import { Component, Input, AfterViewInit, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'user-item',
	templateUrl: 'user-item.html'
})
export class UserItemComponent implements AfterViewInit {

	@Input('data') userDetail: any = {}
	@Input('task') task = "";
	@Output('onSendMessage') onSendMessage: EventEmitter<any> = new EventEmitter();
	@Output('onCall') onCall: EventEmitter<any> = new EventEmitter();
	@Output('onSelectUser') onSelectUser: EventEmitter<any> = new EventEmitter();

	constructor() {

	}

	ngAfterViewInit() {

	}

	showUserOptions() {
		if (!this.userDetail.useroptions)
			this.userDetail.useroptions = true;
		else
			this.userDetail.useroptions = false;


	}

	selectUser(selected){

		this.onSelectUser.emit({
			user: this.userDetail,
			added:selected
		})		
		
	}

}



// WEBPACK FOOTER //
// ./src/components/user-item/user-item.ts